import { render, staticRenderFns } from "./TableBootstrap.vue?vue&type=template&id=4cdc2553&scoped=true&"
import script from "./TableBootstrap.vue?vue&type=script&lang=js&"
export * from "./TableBootstrap.vue?vue&type=script&lang=js&"
import style0 from "./TableBootstrap.vue?vue&type=style&index=0&id=4cdc2553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc2553",
  null
  
)

export default component.exports